import { SL_WEB_FREESTAR_MIGRATION } from 'common/treatments';
import useFreestarAdVastTag from 'hooks/useFreestarAdVastTag';
import useSheMediaAdVastTag from 'hooks/useSheMediaAdVastTag';
import { useTreatments } from 'utils/treatments';

const useCamAdVastTag = (hasAdFreeCamPermissions: boolean, camId?: string) => {
  const treatments = useTreatments();
  const isFreestar = treatments?.[SL_WEB_FREESTAR_MIGRATION] === 'on';
  const sheMediaResult = useSheMediaAdVastTag(hasAdFreeCamPermissions, camId, !isFreestar);
  const freestarResult = useFreestarAdVastTag(hasAdFreeCamPermissions, camId, isFreestar);
  return isFreestar ? freestarResult : sheMediaResult;
};

export default useCamAdVastTag;
